import { apiClient } from "@apis/apiClient";

const feature = "sitemap";

/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
  getByOrg(params: any) {
    return apiClient.get(`/rest/${feature}/`, { params: params });
  },

  getByOrgCheckVisibility(params: any) {
    return apiClient.get(`/rest/${feature}/visibility/`, { params: params });
  },

  getSiteMapById(id: any) {
    return apiClient.get(`/rest/${feature}/${id}`);
  },

  createSiteMap(params: any) {
    return apiClient.post(`/rest/${feature}/`, params, {
      headers: { "content-type": "application/json" },
    });
  },

  updateSiteMap(id: any, params: any) {
    return apiClient.put(`/rest/${feature}/${id}`, params, {
      headers: { "content-type": "application/json" },
    });
  },

  delete(id: any) {
    return apiClient.delete(`/rest/${feature}/${id}`);
  },
};
